import { render } from "./InventoryStockStatus.vue?vue&type=template&id=4fbdca30&scoped=true"
import script from "./InventoryStockStatus.vue?vue&type=script&lang=js"
export * from "./InventoryStockStatus.vue?vue&type=script&lang=js"

import "./InventoryStockStatus.vue?vue&type=style&index=0&id=4fbdca30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbdca30"]])

export default __exports__